import { varGlobal } from "../shared/varGlobal";
import { Injectable } from "@angular/core";
import { AppSettingsService } from "./appsettings.service";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { BehaviorSubject } from "rxjs/BehaviorSubject";

/**
 *  Service de gestion des activites
 */
@Injectable()
export class ActiviteService extends BehaviorSubject<any[]> {
  /** Chemin vers l'API */
  public w_baseUrl: string = "";

  /**
   * Constructeur
   */
  constructor(
    public http: HttpClient,
    public s_appsettings: AppSettingsService,
    public s_global: varGlobal
  ) {
    super([]);
    this.w_baseUrl = this.s_global.pathAPI + "/activite";
  }

  /** Data suivante */
  public proc_next(data) {
    if (data != null) super.next(data);
    else super.next([]);
  }

  /**
   * Fonction de recuperation de toutes les activites
   * Retour : json avec la liste de toutes les activites
   */
  public proc_getAll(): Observable<any> {
    return this.http.get(
      `${this.w_baseUrl}/getall`,
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction de recuperation d'une activite par son id
   * Parametres : activiteId de activite
   * Retour : json avec l'activite
   */
  public proc_getById(id: number): Observable<any> {
    return this.http.get(
      `${this.w_baseUrl}/${id}`,
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction d'ajout d'une activite dans la BDD
   * Parametres : activite a ajouter
   */
  public proc_add(activite: any): Observable<any> {
    return this.http.post(
      `${this.w_baseUrl}/add`,
      JSON.stringify(activite),
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction de mise a jour d'une activite dans la BDD
   * Parametres : activite a modifier
   */
  public proc_update(activite: any): Observable<any> {
    return this.http.post(
      `${this.w_baseUrl}/update`,
      JSON.stringify(activite),
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction de suppression d'une activite dans la BDD
   * Parametres : activite a supprimer
   */
  public proc_delete(activite: any): Observable<any> {
    return this.http.post(
      `${this.w_baseUrl}/delete`,
      JSON.stringify(activite),
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction estUtilise pour verifier si les données a supprimer sont utilisés
   * Parametres : activiteId
   */
  public proc_estUtilise(activiteId: number): Observable<any> {
    return this.http.get(
      `${this.w_baseUrl}/estUtilise/${activiteId}`,
      this.s_appsettings.proc_getHeaders()
    );
  }
}



// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/services/activite.service.ts